
import { defineComponent } from 'vue';
import TopBar from '@/components/TopBar.vue'
export default defineComponent({
    name: 'HomeView',
    components: {
        TopBar,
    },
});
